<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="ded" id="ded"><em>To Adam Hall, and Quiller</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?05c9f180